module.exports = [{"name":"sidebar.billingpackageserviceused","icon":"fas fa-cloud-upload-alt","router":{"name":"BillingPackageServiceUsed"},"activeClass":""},{"name":"sidebar.billingpackagehistory","icon":"fas fa-history","router":{"name":"BillingPackageHistory"},"activeClass":""},{"name":"sidebar.billingpackagepaymentmethod","icon":"fas fa-credit-card","router":{"name":"BillingPackagePaymentMethod"},"activeClass":""}]


//////////////////
// WEBPACK FOOTER
// ./src/components/apps/billingpackage/sidebar.json
// module id = SvgW
// module chunks = 1